import Alpine from 'alpinejs'
import Plyr from 'plyr'
import Hls from 'hls.js'
import 'plyr/css'

export const videoEmbedLoader = (): void => {
    Alpine.data('initLoadVideo', () => ({
        init() {
            const video: HTMLVideoElement | null = this.$refs.video
            const source = this.$refs.videoSource.src

            if (!video || !source) {
                return
            }

            new Plyr(video)

            if (Hls.isSupported()) {
                const hls = new Hls()
                hls.loadSource(source)
                hls.attachMedia(video)
            }
        },
    }))
}
